// extracted by mini-css-extract-plugin
export default {"Password":"Password_Password__dLerx","Password-dialog":"Password_Password-dialog__0TOAH"};